export default __webpack_public_path__ + "static/media/650.1417dcf4.png";